export function getIMC(taille: number, poids: number): number {
    return poids / Math.pow((taille / 100), 2);
}